import { bodycamClient, rmsClient } from "./clients";
import { VideoData } from "../shared/interfaces/VideoData";

export interface ReportMetadataRecord {
  stationId: string;
  reportId: string;
  userId: string;
  rms: string;
  reportStatus: string;
  reportDescription?: string | null;
  reportModifiedById: string;
  reportSignedById?: string | null;
  signedAt?: string | null;
  rmsCommitById?: string | null;
  rmsCommitAt?: string | null;
  evidenceIds: string[];
  promptTokenUsage?: number;
  completionTokenUsage?: number;
  createdAt: string;
  updatedAt: string;
  // Server-set on POST /reports/{id}/review (REPORT_REVIEW_API_REFERENCE.md §5.4).
  // reviewedAt is the timestamp of the latest CO action (approve or reject)
  // and is cleared on retract. reportStatus disambiguates approve vs reject.
  reviewedBy?: string | null;
  reviewedByName?: string | null;
  reviewedAt?: string | null;
}

interface ReportMetadataResponse extends ReportMetadataRecord {
  canEdit: boolean;
}

export const getReportMetadata = async (
  reportId: string,
): Promise<ReportMetadataResponse> => {
  const response = await rmsClient.get<ReportMetadataResponse>("/report", {
    params: { reportId },
  });

  return response.data;
};

export const getEvidenceData = async (
  evidenceId: string,
): Promise<VideoData> => {
  const response = await bodycamClient.get<VideoData>("/evidence/details", {
    params: { evidenceId },
  });

  return response.data;
};

export const getIncidentData = async (
  reportId: string,
  versionNumber?: number,
) => {
  const params: Record<string, string | number> = { reportId };
  if (typeof versionNumber === "number") params.version = versionNumber;
  const response = await rmsClient.get("/artifact", { params });

  return response.data;
};

export const signReport = async (reportId: string): Promise<void> => {
  await rmsClient.post("/report/sign", { reportId });
};

export const rmsCommitReport = async (
  reportId: string | number,
): Promise<{ eventNumber?: string }> => {
  const res = await rmsClient.post("/report/rms-commit", { reportId });
  return res.data ?? {};
};
